import { CityCellInView, CityCells, CityCellsInViewFilter, CityGeometry, CityPaginationFilterRequest, FillCityCellsFromGeoJson, SaveCityCellsResult, UpsertCity, UpsertCityGeometry } from '@/models/city.model';
import { postReq, putReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { City } from '@/models/city.model';

export const getPagedCities = async (input: CityPaginationFilterRequest): Promise<PagedResponseModel<City>> => {
  return await getReq(createUrl("a/City/pagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getCitiesLookup = async (text?: string, countryId?: number, page?: number): Promise<PaginatedSelectModel> => {
  const model: CityPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: text,
    countryId: countryId,
    isAscending: false
  };
  return await getPagedCities(model).then(data =>
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.name} (${itm.country?.name})`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })       
  );
};

export const getCity = async (id: number): Promise<BaseResponseModel<City>> => {
  return await getReq(createUrl(`a/City/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertCity = async (input: UpsertCity): Promise<BaseResponseModel<City>> => {
  return await postReq(createUrl("a/City/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const upsertCityGeometry = async (input: UpsertCityGeometry): Promise<BaseResponseModel<CityGeometry>> => {
  return await postReq(createUrl("a/City/Geometry/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const getCityCells = async (cityId: number): Promise<BaseResponseModel<CityCells>> => {
  return await getReq(createUrl(`a/City/${cityId}/Cells`)).then((res: any) => res.data);
};

export const saveCityCells = async (cityId: number, cells: string[]): Promise<BaseResponseModel<SaveCityCellsResult>> => {
  return await putReq(createUrl(`a/City/${cityId}/Cells`), { cells }).then((res: any) => res.data);
};

export const fillCityCellsFromGeoJson = async (cityId: number, input: FillCityCellsFromGeoJson): Promise<BaseResponseModel<SaveCityCellsResult>> => {
  return await postReq(createUrl(`a/City/${cityId}/Cells/FromGeoJson`), input).then((res: any) => res.data);
};

export const getCityCellsInView = async (input: CityCellsInViewFilter): Promise<BaseResponseModel<CityCellInView[]>> => {
  return await getReq(createUrl("a/City/Cells/InView"), { params: input }).then((res: any) => res.data);
};
